module.exports = __webpack_public_path__ + "img/light.cf4d0483.png";